module.exports = __webpack_public_path__ + "img/ban_4.f83b38d0.png";